var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7Grey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "31px",
    viewBox: "0 0 23 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MAP/7Grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7Grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1630859,1.98169023 L1.72558594,2.3343868 L1.72558594,11.9668228 L10.6786002,11.4730903 L2.63935595,28.7696462 L14.0342095,29.4220233 C14.1769307,29.0778701 14.2692317,28.8511049 14.3112753,28.7417916 C14.3712201,28.585935 14.5153254,28.1843923 14.7431171,27.5369843 C14.9648792,26.906713 15.2420905,26.1334666 15.5747337,25.2172389 C15.9093584,24.2955533 16.2762733,23.274068 16.6754747,22.1527817 C17.0738023,21.0339495 17.4779878,19.900473 17.888031,18.752352 C18.7690447,16.2812165 19.7434165,13.5496633 20.8113316,10.5571737 L21.1630859,9.57153021 L21.1630859,1.98169023 Z",
    id: 7,
    stroke: "#595959",
    strokeWidth: 2,
    fill: "#F0EEE9",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Grey);
export default __webpack_public_path__ + "static/media/7Grey.1ce6c5de6c0e44e7707d8ac0e7d770bb.svg";
export { ForwardRef as ReactComponent };